import Vue from 'vue';
import VueRouter from 'vue-router';
import NotFound from '@/views/NotFound.vue';
import NotAvailable from '@/views/NotAvailable.vue';
import Landingpage from '@/views/LandingPage.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/not-found',
		name: 'NotFound',
		component: NotFound
	},
	{
		path: '/not-available',
		name: 'NotAvailable',
		component: NotAvailable
	},
	{
		path: '/:landingpageCode?',
		name: 'Landingpage',
		component: Landingpage
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router